import { StringUtilities } from './string.utilities';
import { BasicEmailBlastSubstitutions } from '../models/data/send-bulk-email.model';

export class CommunicationsUtilities {

    // Builds the Basic Email Blast substitution map from the composed fields. The footer is a plain-text input,
    // so it is HTML-escaped with newlines converted to <br/> before being injected verbatim into the email
    // template. The body comes from the WYSIWYG editor and is already HTML — we run a light sanitizer to
    // strip absolutely-dangerous tags/attributes (script, iframe, on* handlers, javascript: URLs, etc.) and
    // trust the API to do the authoritative sanitization.
    public static buildBasicEmailBlastSubstitutions(body: string, footer: string): BasicEmailBlastSubstitutions {
        return {
            '{{ TextContent }}': StringUtilities.sanitizeEmailBody(body),
            '{{ FooterContent }}': StringUtilities.escapeHtmlWithLineBreaks(footer)
        };
    }
}
